import {UserTeam} from '@q9elements/ui-kit/common';

export interface SpaceEntities {
  [key: string]: UserTeam;
}

export interface UserInvitation {
  dataStructureAdmin: boolean;
  email: string;
  importManager: boolean;
  isEditor: boolean;
  message: string;
  releaseAdmin: boolean;
  requirementsManager: boolean;
  resourceAdmin: boolean;
  teamAdmin: boolean;
  urlLibraryManager: boolean;
  workflowIntegrationManager: boolean;
  grantedEditRights: Record<string, boolean>;
}

export type InviteUserApiPayload = UserInvitation;

export type InviteUsersBatchApiPayload = Omit<UserInvitation, 'email'> & {
  emails: string[];
};

export type InviteUserOrBatchApiPayload = InviteUserApiPayload | InviteUsersBatchApiPayload;

export interface FileSelection {
  blob: Blob;
  fileData: string | ArrayBuffer | null | undefined;
  file: File;
}

export enum TAB_TYPES {
  MY = 'my',
  PUBLIC = 'public'
}
